import applyLocaleDecimalSeparator from '../applyLocaleDecimalSeparator';

export default (score) => {
  // Handle invalid/null/undefined scores
  if (score == null || score === undefined) {
    return 'n/a';
  }

  // Coerce to number so we never call toFixed on a string (e.g. from roundToOne/API)
  const n = Number(score);

  // Handle -1 (not available)
  if (n === -1) {
    // Check if French or Portuguese for "nd" instead of "n/a"
    if (typeof window !== 'undefined') {
      const isFRorPT = window.active_language === 2 || window.active_language === 4 || (window.localStorage && (window.localStorage.getItem('i18nextLng') === 'fr' || window.localStorage.getItem('i18nextLng') === 'pt'));
      return isFRorPT ? 'nd' : 'n/a';
    }
    return 'n/a';
  }

  // Handle NaN
  if (Number.isNaN(n)) {
    return 'n/a';
  }

  // Format the number - cap at 2 decimal places to avoid float precision noise (e.g. chart values)
  let formatted;
  if (n % 1 === 0) {
    formatted = `${n}.0`;
  } else {
    formatted = n.toFixed(2);
    // Trim single trailing zero so 41.20 -> 41.2, 41.23 stays 41.23
    if (formatted.endsWith('0') && !formatted.endsWith('00')) {
      formatted = formatted.slice(0, -1);
    }
  }

  // Apply locale-aware decimal separator
  return applyLocaleDecimalSeparator(formatted);
};
